import React, { useRef } from "react";
import { 
  GoogleMap, 
  Data, 
  useLoadScript, 
  Autocomplete 
} from "@react-google-maps/api";
import { googleMapsApiKey } from "../config";

const defaultCenter = {
  lat: 24.7679888,
  lng: 46.6654890
};
const libraries = ["places"]; // Define the libraries array outside the component

const Map = (props) => {
  const {
    apiKey,
    center,
    children,
    mapProps,
    dataProps,
    onClick,
    onLoad
  } = props;

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: apiKey || googleMapsApiKey,
    libraries: libraries
  });

  const G = useRef(undefined);
  const MAP = useRef(undefined);
  const autocompleteRef = useRef(null); // Ref for Autocomplete

  if (!G.current) {
    G.current = window.google;
  }

  const centerValid = typeof center === "object" && center.lat && center.lng;

  const handlePlaceSelect = () => {
    const place = autocompleteRef.current.getPlace();
    if (place.geometry && MAP.current) {
      const { location } = place.geometry;
      MAP.current.panTo(location);
      MAP.current.setZoom(16);
      
  // Trigger the onClick callback if provided
  if (onClick) {
    const syntheticEvent = {
      latLng: location,
      place,
    };
    onClick(syntheticEvent);
  }


    }
  };

  if (loadError) {
    return <div>Error loading Google Maps</div>;
  }

  return isLoaded ? (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      {/* Search Box */}
      <div style={{ position: "absolute", top: "10px", left: "10px", zIndex: 1 }}>
        <Autocomplete
          onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
          onPlaceChanged={handlePlaceSelect}
        >
          <input
            type="text"
            placeholder="أبحث فى الخريطة"
            style={{
              width: "300px",
              height: "40px",
              padding: "10px",
              fontSize: "14px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)"
            }}
          />
        </Autocomplete>
      </div>
      {/* Map */}
      <GoogleMap
        zoom={16}
        id="google-map"
        center={centerValid ? center : defaultCenter}
        mapContainerStyle={{ width: "100%", height: "100%" }}
        {...mapProps}
        onClick={(e) => {
          if (MAP.current) {
            MAP.current.panTo(e.latLng);
            onClick && onClick(e);
          }
        }}
        onLoad={(map) => {
          MAP.current = map;
          onLoad && onLoad(MAP.current);
        }}
      >
        <Data {...dataProps} />
        {children}
      </GoogleMap>
    </div>
  ) : (
    <div>Loading...</div>
  );
};

export default Map;
